import { useContext } from 'react';
import { AdminIntroductions } from '@platform/client';
import { AdminTableContext } from '../../AdminTable';
import { useQueryClient } from '@tanstack/react-query';
import { BatchImportModal } from '../../components/BatchImportModal';

const INTRODUCTION_IMPORT_TEMPLATE =
  'https://movingworldspublic.blob.core.windows.net/public/introduction_import_template.csv';

export const ImportIntroductionsModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  const queryClient = useQueryClient();
  const { adminQueryOptionsV2 } = useContext(AdminTableContext);
  const batchImportIntroMutation = AdminIntroductions.useBatchImportIntroductions({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [...AdminIntroductions.getGetIntroductionsQueryKey({ ...adminQueryOptionsV2 })],
        });
      },
    },
  });

  return (
    <BatchImportModal
      recordType='introductions'
      templateFileUrl={INTRODUCTION_IMPORT_TEMPLATE}
      onClose={onClose}
      isOpen={isOpen}
      mutation={{
        ...batchImportIntroMutation,
        mutate: (file) => batchImportIntroMutation.mutate({ data: { file } }),
      }}
    />
  );
};
